interface IntroBiographyScreenProps {
  onNext: () => void;
}

export default function IntroBiographyScreen({ onNext }: IntroBiographyScreenProps) {
  const dots = [
    { x: '8%', size: 10, label: 'Март' },
    { x: '28%', size: 14, label: 'Июнь' },
    { x: '50%', size: 10, label: 'Сент' },
    { x: '72%', size: 16, label: 'Нояб' },
    { x: '92%', size: 12, label: 'Дек' },
  ];

  return (
    <div
      className="flex flex-col w-full h-screen"
      style={{
        background: 'linear-gradient(170deg, #1A1B2E 0%, #2D1B3D 60%, #1F1A35 100%)',
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {/* Progress dots */}
      <div className="flex justify-center gap-2 pt-12 pb-4">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              width: i === 0 ? '20px' : '6px', height: '6px',
              borderRadius: '3px',
              background: i === 0 ? '#3ECFA0' : 'rgba(255,255,255,0.2)',
            }}
          />
        ))}
      </div>

      {/* Icon */}
      <div className="flex justify-center pt-8 pb-6">
        <div
          style={{
            width: '80px', height: '80px',
            borderRadius: '24px',
            background: 'rgba(62,207,160,0.12)',
            border: '1px solid rgba(62,207,160,0.25)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <i className="ri-book-open-line text-4xl" style={{ color: '#3ECFA0' }} />
        </div>
      </div>

      {/* Text */}
      <div className="px-7 flex-1">
        <p style={{ fontSize: '22px', fontWeight: 700, color: '#F5F5F7', lineHeight: 1.35, marginBottom: '16px' }}>
          Омут Памяти не просто сохраняет голосовые сообщения.
        </p>
        <p style={{ fontSize: '16px', fontWeight: 400, color: '#A8B2C8', lineHeight: 1.7 }}>
          Он анализирует их и постепенно помогает собирать вашу личную автобиографию — воспоминание за воспоминанием.
        </p>

        {/* Timeline card */}
        <div
          className="mt-8 rounded-3xl"
          style={{
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.08)',
            padding: '20px 20px',
            backdropFilter: 'blur(20px)',
          }}
        >
          <p style={{ fontSize: '12px', color: '#6B7A94', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>2025 — ваш год</p>
          <div style={{ position: 'relative', height: '40px' }}>
            {/* Line */}
            <div
              style={{
                position: 'absolute', top: '50%', left: 0, right: 0, height: '2px',
                background: 'linear-gradient(90deg, rgba(62,207,160,0.8), rgba(139,122,184,0.5))',
                transform: 'translateY(-50%)',
                borderRadius: '1px',
              }}
            />
            {/* Dots */}
            {dots.map((d, i) => (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: d.x,
                  transform: 'translate(-50%, -50%)',
                  width: `${d.size}px`, height: `${d.size}px`,
                  borderRadius: '50%',
                  background: `linear-gradient(135deg, #3ECFA0, #8B7AB8)`,
                  border: '2px solid rgba(255,255,255,0.3)',
                  boxShadow: '0 2px 8px rgba(62,207,160,0.4)',
                }}
              />
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
            {dots.map((d) => (
              <span key={d.label} style={{ fontSize: '10px', color: '#6B7A94' }}>{d.label}</span>
            ))}
          </div>
        </div>
      </div>

      {/* Button */}
      <div
        className="px-7"
        style={{ paddingBottom: 'calc(32px + env(safe-area-inset-bottom))' }}
      >
        <button
          onClick={onNext}
          className="w-full active:scale-95 transition-transform duration-150"
          style={{
            height: '56px', borderRadius: '28px',
            background: 'linear-gradient(135deg, #3ECFA0, #2BA87F)',
            border: 'none', fontSize: '17px', fontWeight: 600, color: '#fff',
            cursor: 'pointer', boxShadow: '0 8px 24px rgba(62,207,160,0.35)',
          }}
        >
          Далее
        </button>
      </div>
    </div>
  );
}
